export default {
    SET_PARAMETROS: 'setParametros',
    SET_LICITACAO: 'setLicitacao',
    LOKI: {
        SET_FILES_API:'setFilesApi',
        DISABLE_GLOBAL_LOADING: 'disableGlobalLoading',
        ENABLE_GLOBAL_LOADING: 'enableGlobalLoading',
        SET_GLOBAL_LOADING: 'setGlobalLoading',
        SET_LOADING_MESSAGE: 'setLoadingMessage',
        SET_NOTIFICATION: 'setNotification',
        SET_TIMEZONE: 'setTimezone',
        SHOW_ALERT: 'showAlert'
    }
}
